import { X, Smartphone } from "lucide-react";
import { Button } from "@components/ui/button";
import { useMobileAppBanner } from "./useMobileAppBanner";

export const MobileAppBanner: React.FC = () => {
  const { isMobile, dismissed, dismiss, appUrl } = useMobileAppBanner();

  if (!isMobile || dismissed) {
    return null;
  }

  return (
    <div className="flex items-center justify-between gap-2 bg-primary px-4 py-2 text-primary-foreground">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Smartphone className="size-4 shrink-0" />
        <span>Open in the PES app</span>
      </div>
      <div className="flex items-center gap-1">
        <Button
          variant="secondary"
          size="sm"
          className="h-7 text-xs"
          asChild
        >
          <a href={appUrl}>Open</a>
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="size-7 text-primary-foreground hover:bg-primary-foreground/20 hover:text-primary-foreground"
          onClick={dismiss}
        >
          <X className="size-4" />
          <span className="sr-only">Dismiss</span>
        </Button>
      </div>
    </div>
  );
};
